"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loadable = exports.Loader = void 0;

var React = require("react");

var styled_components_1 = require("styled-components");

var utils_1 = require("../../utils");

var Flex_1 = require("../Flex");

var Ring_1 = require("./animations/Ring");

var Balls_1 = require("./animations/Balls");

function Loader(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 'md' : _b,
      color = _a.color,
      alternate = _a.alternate,
      animation = _a.animation;
  var theme = styled_components_1.useTheme();

  var _c = utils_1.getComponentThemeStyles(theme, 'Loadable', 'default', size),
      width = _c.width,
      height = _c.height,
      themeColor = _c.color,
      defaultAnimation = _c.defaultAnimation,
      themeStyles = __rest(_c, ["width", "height", "color", "defaultAnimation"]);

  var animationColor = color || themeColor;
  var selectedAnimation = animation || defaultAnimation;

  if (selectedAnimation === 'ring') {
    return React.createElement(Ring_1.default, {
      height: themeStyles.amount,
      width: themeStyles.amount,
      color: animationColor
    });
  }

  return React.createElement(Balls_1.default, {
    color: animationColor,
    alternate: alternate,
    themeStyles: themeStyles,
    height: height,
    width: width
  });
}

exports.Loader = Loader;

function Loadable(_a) {
  var _b = _a.loading,
      loading = _b === void 0 ? false : _b,
      children = _a.children,
      _c = _a.alternate,
      alternate = _c === void 0 ? false : _c,
      color = _a.color,
      _d = _a.size,
      size = _d === void 0 ? 'md' : _d,
      animation = _a.animation,
      minHeight = _a.minHeight;
  return React.createElement(React.Fragment, null, loading ? React.createElement(Flex_1.Flex, {
    alignItems: "center",
    height: "100%",
    justifyContent: "center",
    minHeight: minHeight
  }, React.createElement(Loader, {
    animation: animation,
    color: color,
    size: size,
    alternate: alternate
  })) : children);
}

exports.Loadable = Loadable;